





























import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'

export default BaseCmsBlock.extend({
    name: "HeadTeaserBlock",
    data: function () {
        return {};
    },

    computed: {
        logoSrc() {
            return this.extras?.logo;
        },
        title() {
            return this.extras?.title;
        },
    },
});
